'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M0 0v1024h1024v-1024h-1024zM960 960h-896v-896h896v896z' }),
        React.createElement('path', { d: 'M160 512l96-96 160 160 352-352 96 96-448 448z' })
    ));
};